import React from 'react';

interface Props {
  open: boolean;
  /** 実際に閉じる（＝離脱する）。 */
  onLeave: () => void;
  /** 留まる（確認を閉じてウィザードに戻る）。 */
  onStay: () => void;
}

// 旧 styled 定義をそのまま Tailwind クラス文字列にした定数。
const OVERLAY =
  'fixed inset-0 z-[10000] grid place-items-center p-5 bg-[rgba(19,22,40,0.52)] backdrop-blur-[3px]';
const DIALOG =
  'w-[min(460px,100%)] p-7 rounded-2xl bg-white shadow-[0_24px_70px_rgba(0,0,0,0.24)]';
const ICON =
  'grid place-items-center w-12 h-12 mb-4 rounded-full bg-[rgba(124,58,237,0.12)] text-[#7c3aed] text-[1.4rem]';
const TITLE = 'm-0 mb-2.5 text-[1.2rem] text-gray-800';
const COPY = 'm-0 mb-[22px] text-[0.9rem] leading-[1.7] text-[#62677a]';
const ACTIONS = 'flex justify-end gap-2.5';
const BUTTON_BASE = 'min-h-[42px] px-[18px] rounded-lg font-bold cursor-pointer border';
const BUTTON_PRIMARY = 'border-primary bg-primary text-white';
const BUTTON_DEFAULT = 'border-[#d1d5db] bg-white text-[#374151]';

/**
 * 無料バナー10枚を作れる状態で閉じようとしたときの引き留め確認。
 * SignupSkipConfirmation のデザインを踏襲。
 */
const BannerExitConfirmation: React.FC<Props> = ({ open, onLeave, onStay }) =>
  open ? (
    <div className={OVERLAY} role="presentation" onMouseDown={onStay}>
      <div
        className={DIALOG}
        role="dialog"
        aria-modal="true"
        aria-labelledby="banner-exit-title"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className={ICON} aria-hidden>✦</div>
        <h2 className={TITLE} id="banner-exit-title">バナー10枚を無料で作成できます</h2>
        <p className={COPY}>
          初回限定です。本当に閉じますか？
        </p>
        <div className={ACTIONS}>
          <button className={`${BUTTON_BASE} ${BUTTON_DEFAULT}`} type="button" onClick={onLeave}>
            閉じる
          </button>
          <button className={`${BUTTON_BASE} ${BUTTON_PRIMARY}`} type="button" onClick={onStay}>
            続ける
          </button>
        </div>
      </div>
    </div>
  ) : null;

export default BannerExitConfirmation;
